import $ from 'jquery';

const $header = $( '.js-header' );

if ( $header.length ) {
	$( window ).on( 'scroll', function() {
		const $self = $( this );

		if ( $self.scrollTop() > 150 ) {
			$header.addClass( 'header--small' );
		} else {
			$header.removeClass( 'header--small' );
		}
	} );
}
